import { createI18n } from "vue-i18n";

const messages = {
    id: {
        AlasanMemilih: "Apa alasan Anda memilih Universitas Pancasila?",
        KriteriaMemilih: "Apa kriteria Anda dalam memilih Perguruan Tinggi?",
        SilahkanLengkapiDataAnda: "Silahkan Lengkapi Data Anda",
        LengkapiNominalSumbangan: "Lengkapi Nominal Sumbangan",
        LengkapiJadwalTes: "Lengkapi Jadwal Tes",
        LengkapiFile: "Lengkapi File yang wajib anda upload",
        LengkapiProgramStudi:
            "Lengkapi Program Studi Pilihan yang anda minati di bagian bawah",
        //
        NamaLengkap: "Nama Lengkap",
        TTL: "Tempat / Tanggal Lahir",
        PendidikanTerakhir: "Pendidikan Terakhir",
        Kota: "Kabupaten/Kota",
        Provinsi: "Provinsi",
        Kecamatan: "Kecamatan",
        Kelurahan: "Kelurahan",
        Alamat: "Alamat",
        NamaSekolah: "Nama Sekolah",
        Foto: "Foto",
        JenisKelamin: "Jenis Kelamin",
        Lakilaki: "Laki-laki",
        Perempuan: "Perempuan",
        TempatLahir: "Tempat Lahir",
        TanggalLahir: "Tanggal Lahir",
        UkuranBaju: "Ukuran Baju",
        Agama: "Agama",
        Suku: "Suku",
        KodePos: "Kode Pos",
        Batal: "Batal",
        Simpan: "Simpan",
        ProfilLengkap: "Profil Lengkap",
        JenisSekolahAsal: "Jenis Sekolah Asal",
        JurusanSekolahAsal: "Jurusan Sekolah Asal",
        Sumberinformasi: "Sumber informasi",
        "DarimanaAndamengetahuitentangUniversitasPancasila?": "Dari mana Anda mengetahui tentang Universitas Pancasila?",
        "ApakriteriautamaAndadalammemilihPerguruanTinggi?": "Apa kriteria utama Anda dalam memilih Perguruan Tinggi?",
        "ApaalasanAndamemilihUniversitasPancasila?": "Apa alasan Anda memilih Universitas Pancasila?",
        PilihSumberInformasi: "Pilih Sumber Informasi",
        PilihAlasan: "Pilih Alasan",
        Actions: "Aksi",
        Kode: "Kode",
        Program: "Program",
        Jalur: "Jalur",
        JadwalTes: "Jadwal Tes",
        Status: "Status",
        LogInfo: "Info Aktifitas",
        CariData: "Cari Data",
        PilihJalurDaftar: "Pilih Jalur Daftar",
        Kembali: "Kembali",
        KodePendaftaran: "Kode Pendaftaran",
        ProgramPilihan: "Program Pilihan",
        JalurPilihan: "Jalur Pilihan",
        NamaMahasiswa: "Nama Mahasiswa/i",
        Keterangan: "Keterangan",
        Aktif: "Aktif",
        TidakAktif: "Tidak Aktif",
        NominalSumbangan: "Nominal Sumbangan",
        JumlahPilihanProgram: "Jumlah Pilihan Program",
        PilihPembayaran: "Pilih Pembayaran",
        PrintKartuPembayaran: "Print Kartu Pembayaran",
        PilihProgramPilihan: "Pilih Program Pilihan",
        Cetak: "Cetak",
        MenungguHasil: "Menunggu Hasil",
        Diterima: "Diterima",
        TidakDiterima: "Tidak Diterima",
        ListFile: "List File",
        UploadFile: "Upload File",
        Success: "Success",
        Gagal: "Gagal",
        KartuPendaftaranMahasiswa: "Kartu Pendaftaran Mahasiswa",
        PeriodePendaftaran: "Periode Pendaftaran",
        Informasi: "Informasi",
        //
        totalPendaftaran: "Total Pendaftaran",
        totalLulus: "Total yang Lulus",
        totalSudahBayar: "Total yang Sudah Bayar",
        //Menu
        Home: "Home",
        ProfileSaya: "Profile Saya",
        Bahasa: "Bahasa",
        Keluar: "Keluar",
        Preview: "Preview",
        Mahasiswa: "Mahasiswa",
        ProfilMahasiswa: "Profil Mahasiswa",
        PengaturanProfil: "Pengaturan Profil",
        KuesionerSingkat: "Kuesioner Singkat",
        SettingPendidikanTerakhir: "Setting Pendidikan Terakhir",
        PembayaranMahasiswa: "Pembayaran Mahasiswa",
        Master: "Master",
        Settings: "Settings",
        Laporan: "Laporan",
        Cicilan: "Cicilan",
        Pendaftaran: "Pendaftaran",
        KonfirmasiKelulusan: "Konfirmasi Kelulusan",
    },
    en: {
        AlasanMemilih: "What is your reason for choosing Pancasila University?",
        KriteriaMemilih: "What are your criteria in choosing a College?",
        SilahkanLengkapiDataAnda: "Please Complete Your Data",
        LengkapiNominalSumbangan:
            "Complete the Donation Amount and press the Save Changes button",
        LengkapiJadwalTes: "Complete Test Schedule",
        LengkapiFile: "Complete the files that you must upload",
        LengkapiProgramStudi:
            "Complete the Preferred Study Program that you are interested in at the bottom",
        //
        NamaLengkap: "Full name",
        TTL: "Place and Date of Birth",
        PendidikanTerakhir: "Last Education",
        totalPendaftaran: "Registration Totals",
        Kota: "City",
        Provinsi: "Province",
        Kecamatan: "Subdistrict",
        Kelurahan: "Urban village",
        Alamat: "Address",
        Foto: "Photo",
        JenisKelamin: "Gender",
        Lakilaki: "Male",
        Perempuan: "Female",
        TempatLahir: "Place of Birth",
        TanggalLahir: "Date of Birth",
        UkuranBaju: "Clothes Size",
        Agama: "Religion",
        Suku: "Ethnic group",
        KodePos: "Postal Code",
        Batal: "Discard",
        Simpan: "Save",
        ProfilLengkap: "Detail Profile",
        JenisSekolahAsal: "Origin School Type",
        JurusanSekolahAsal: "Origin School Major",
        Sumberinformasi: "Resources",
        "DarimanaAndamengetahuitentangUniversitasPancasila?": "Where did you hear about Pancasila University?",
        "ApakriteriautamaAndadalammemilihPerguruanTinggi?": "What are your main criteria in choosing a College?",
        "ApaalasanAndamemilihUniversitasPancasila?": "What is your reason for choosing Pancasila University?",
        PilihSumberInformasi: "Select Information Source",
        PilihAlasan: "Select Reason",
        Actions: "Actions",
        Kode: "Code",
        Program: "Program",
        Jalur: "Track",
        JadwalTes: "Test Schedule",
        Status: "Status",
        LogInfo: "Activity Info",
        CariData: "Search Data",
        PilihJalurDaftar: "Select Registration",
        Kembali: "Back",
        KodePendaftaran: "Registration Code",
        ProgramPilihan: "Preferred Program",
        JalurPilihan: "Jalur Pilihan",
        NamaMahasiswa: "Student name",
        Keterangan: "Information",
        Aktif: "Aktif",
        TidakAktif: "Non Aktif",
        NominalSumbangan: "Contribution Amount",
        JumlahPilihanProgram: "Number of Program Choices",
        PilihPembayaran: "Select Payment",
        PrintKartuPembayaran: "Print Payment Cards",
        PilihProgramPilihan: "Select Preferred Programs",
        Cetak: "Print",
        MenungguHasil: "Waiting for the result",
        Diterima: "Received",
        TidakDiterima: "Not Accepted",
        ListFile: "List File",
        UploadFile: "Upload File",
        Success: "Success",
        Gagal: "Failed",
        KartuPendaftaranMahasiswa: "Student Registration Card",
        PeriodePendaftaran: "Registration Period",
        Informasi: "Information",
        //
        NamaSekolah: "School Name",
        totalLulus: "Total Pass",
        totalSudahBayar: "Paid Total",
        //Menu
        Home: "Dashboard",
        ProfileSaya: "My Profile",
        Bahasa: "Language",
        Keluar: "Sign Out",
        Preview: "Overview",
        Mahasiswa: "Student",
        ProfilMahasiswa: "Student Profile",
        PengaturanProfil: "Profile Setting",
        KuesionerSingkat: "Short Questionnaire",
        SettingPendidikanTerakhir: "Last Educational Setting",
        PembayaranMahasiswa: "Student Payments",
        Master: "Master",
        Settings: "Settings",
        Laporan: "Reports",
        Cicilan: "Instalment",
        Pendaftaran: "Registration",
        KonfirmasiKelulusan: "Confirmation of Graduation",
    },
};

const i18n = createI18n({
    legacy: false,
    locale: "en",
    globalInjection: true,
    messages,
});

export default i18n;
